<template>
  <div
    class="loading-indicator-wrapper"
    :class="enableMinDimensions && loading ? 'loading-indicator-wrapper--min-dimensions' : ''"
  >
    <loading-indicator
      v-if="loading"
      :dark="dark"
      :variant="variant"
      spinoff="in-relative-centered"
    />
    <slot />
  </div>
</template>

<script setup lang="ts">
import LoadingIndicator from '@/components/atoms/loading-indicator/LoadingIndicator.vue';

interface Props {
  loading: boolean | number;
  variant?: string;
  dark?: boolean;
  enableMinDimensions?: boolean;
}

withDefaults(defineProps<Props>(), {
  variant: 'spinnerLocal',
  dark: false,
  enableMinDimensions: false,
});
</script>

<style scoped src="./loading-indicator-wrapper" />
